<template>
  <label class="radio" :class="[{ tick: tick }, { circle: !tick }]">
    <input
      type="radio"
      :value="value"
      :checked="checked"
      name="radio"
      @change="changeValue"
    />
    <span class="checkmark"></span>
  </label>
</template>
<script>
export default {
  name: "Radio",
  props: {
    checked: Boolean,
    tick: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
  },
  methods: {
    changeValue(event) {
      this.$emit("change", event.target.value);
    },
  },
};
</script>
<style>
.radio {
  display: block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 20px;
  height: 20px;
  @apply text-sm;
}

/* Hide the browser's default radio button */
.radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  @apply bg-rdc-gray dark:bg-dark-mode-400;
}

/* On mouse-over, add a grey background color */
.radio:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.radio input:checked ~ .checkmark {
  background-color: #2753e1;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
/* .radio.circle .checkmark:after {
  top: 8px;
  left: 8px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: white;
} */
</style>
